import { emailRegex, passwordRegex, TypeOfUser } from '@pharmaplan/common';
import * as Yup from 'yup';
import strings from '../../../localization';
import { nameRegex } from '../../../helpers/Constants';

// Names and terms are only collected on this screen for full service.
// Self service keeps collecting them inside the signup flow, as before.
const isFullService = process.env.REACT_APP_SERVICE_TYPE !== 'self';

const isProfessionalRole = (role: unknown) =>
  isFullService
  && (role === TypeOfUser.pharmacist || role === TypeOfUser.technician);

// Same rules the names get inside the signup flow: required and no numbers
// or special characters.
const professionalName = () =>
  Yup.string()
    .trim()
    .when('role', {
      is: isProfessionalRole,
      then: (schema) =>
        schema
          .required(strings.requiredField)
          .matches(nameRegex, strings.pleaseEnterValidName),
    });

const Validator = () =>
  Yup.object().shape({
    email: Yup.string()
      .matches(emailRegex, strings.emailValid)
      .trim()
      .required(strings.requiredField),
    firstName: professionalName(),
    lastName: professionalName(),
    role: Yup.string().required(strings.requiredField),
    password: Yup.string().when('isMediaLogin', {
      is: false,
      then: () =>
Yup.string()
  .required(strings.requiredField)
  .matches(passwordRegex, strings.minCharacters) as any,
    }),
    confirmPassword: Yup.string().when('isMediaLogin', {
      is: false,
      then: () =>
        Yup.string()
          .equals([Yup.ref('password')], strings.passwordsMustMatch)
          .required(strings.requiredField),
    }),
    language: Yup.string().required(strings.requiredField),
    termsAndConditions: Yup.bool().oneOf(
      isFullService ? [true] : [true, false],
      strings.termsAndConditionsValidation,
    ),
  });

export default Validator;
